"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _QueuesStore = _interopRequireDefault(require("crm_data/queues/QueuesStore"));

var _EngagementsStore = _interopRequireDefault(require("crm_data/engagements/EngagementsStore"));

var TasksQueueMediator = _interopRequireWildcard(require("crm_ui/queues/QueuesMediator"));

var _ImmutableEngagementModel = require("customer-data-objects/model/ImmutableEngagementModel");

var _hubspotFluxStores = _interopRequireDefault(require("hubspot.flux.stores.NavigationStore"));

var _TaskPlaylistRecord = _interopRequireDefault(require("crm_data/queues/TaskPlaylistRecord"));

var _getValidTasks = function _getValidTasks(tasks, queueTaskId) {
  return tasks.reduce(function (acc, task) {
    if (!task) {
      return acc;
    } // we dont want to exclude the active task


    if (String((0, _ImmutableEngagementModel.getId)(task)) === queueTaskId && TasksQueueMediator.taskHasValidAssociation(task)) {
      return acc.push(task);
    }

    if (!TasksQueueMediator.taskIsValid(task)) {
      return acc;
    }

    return acc.push(task);
  }, (0, _immutable.List)());
};

var QueuesPlaylistDeps = {
  stores: [_EngagementsStore.default, _QueuesStore.default, _hubspotFluxStores.default],
  deref: function deref(_ref) {
    var taskId = _ref.taskId,
        queueId = _ref.queueId,
        nextTaskId = _ref.nextTaskId;

    var navigationStore = _hubspotFluxStores.default.get();

    if (!navigationStore) {
      return undefined;
    }

    var queryParams = navigationStore.queryParams || {};
    queueId = queryParams.queueId || queueId;
    taskId = queryParams.taskId || taskId;
    nextTaskId = queryParams.nextTaskId || nextTaskId;
    var interaction = queryParams.interaction,
        redirectUrl = queryParams.redirectUrl;

    if (!queueId || !taskId) {
      return undefined;
    }

    var queues = _QueuesStore.default.get();

    if (!queues || !queueId && !taskId) {
      return null;
    }

    var nextTask;
    var activeQueue = queues.get(parseInt(queueId, 10));

    if (!activeQueue) {
      return null;
    }

    var activeTask = _EngagementsStore.default.get(taskId);

    var tasksIds = activeQueue.get('engagementIds');

    var tasks = _EngagementsStore.default.get(tasksIds);

    var validTasks = _getValidTasks(tasks, taskId);

    activeQueue = activeQueue.set('engagementIds', validTasks.map(function (task) {
      return (0, _ImmutableEngagementModel.getId)(task);
    }));

    if (nextTaskId) {
      nextTask = _EngagementsStore.default.get(nextTaskId);
    }

    return new _TaskPlaylistRecord.default({
      activeTask: activeTask,
      interaction: interaction,
      nextTask: nextTask,
      activeQueue: activeQueue,
      redirectUrl: redirectUrl,
      tasks: validTasks,
      title: activeQueue.get('name')
    });
  }
};
var _default = QueuesPlaylistDeps;
exports.default = _default;
module.exports = exports.default;